/**
 *
 * Date
 *
 */

import moment from 'moment';
import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { Button, Icon } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';

import * as datesConstants from '../../CustomDatePicker/dateTime.constants';
import './DateInputField.styles.less';

import '../../CustomDatePicker/react-datepicker.less';
import './customDatePicker.styles.less';

class DateInputField extends React.PureComponent {
  static propTypes = {
    disabled: PropTypes.bool,
    // value: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    prefix: PropTypes.string,
    error: PropTypes.string,
    locale: PropTypes.string.isRequired,
    localeDateFormat: PropTypes.string.isRequired,
    businessTimezone: PropTypes.string.isRequired,
    name: PropTypes.string,
    showYearDropdown: PropTypes.bool,
    minDate: PropTypes.object,
    maxDate: PropTypes.object,
    popperPlacementPositions: PropTypes.string
  };

  onChange = (value) => {
    const momentObj = value ? moment(value) : undefined;
    const newData = {
      name: this.props.name,
      value: momentObj ? momentObj.format(datesConstants.DATE_ONLY_FORMAT) : undefined
    };
    this.props.onChange(value, newData);
  };

  get value() {
    return moment(this.props.value, datesConstants.DATE_ONLY_FORMAT);
  }

  get triggerText() {
    return this.value.format(this.props.localeDateFormat);
  }

  momentToDate = (momentObject) => {
    if (momentObject) {
      return momentObject.toDate();
    }
    return null;
  };

  fixEmptyDt = (value, label) => value === null && label === 'Invalid date' ? '' : label;

  render() {
    const selected = this.props.value
      ? moment(this.props.value, datesConstants.DATE_ONLY_FORMAT)
      : moment();

    return (
      <div className="date-input-field">
        <DatePicker
          timeZone={this.props.businessTimezone}
          data-automation-id={this.props.prefix}
          locale={this.props.locale}
          onChange={this.onChange}
          selected={this.momentToDate(selected)}
          placeholderText="test placeholder"
          disabled={this.props.disabled}
          isClearable={this.props.value}
          shouldCloseOnSelect
          dateFormatCalendar="MMMM"
          showYearDropdown={
            typeof this.props.showYearDropdown !== 'undefined'
              ? this.props.showYearDropdown
              : true
          }
          scrollableYearDropdown
          yearDropdownItemNumber={100}
          customInput={
            <Button
              basic
              className="link"
              data-automation-id={`${this.props.prefix}.input`}
            >
              <span>{this.fixEmptyDt(this.props.value, this.triggerText)}</span>
              <Icon className="como-ic-date" />
            </Button>
          }
          error={this.props.error}
          fixedHeight
          minDate={this.momentToDate(this.props.minDate)}
          maxDate={this.momentToDate(this.props.maxDate)}
          popperModifiers={{
            preventOverflow: {
              enabled: true,
            },
          }}
        />
      </div>
    );
  }
}

export default injectIntl(DateInputField);
